import {
  mapState
} from "vuex";
import {
  maxBy
} from 'lodash';

export default {
  data() {
    return {
      TERM_CHOICES: [
        {title: 'بلند مدت', value: true},
        {title: 'کوتاه مدت ', value: false},
      ],
      BANK_NAMES: [
        { name: ' آینده', value: 'BAYAN' },
        { name: 'استاندارد چارترد', value: 'CHART' },
        { name: ' اقتصاد نوین', value: 'BEGHTE' },
        { name: ' ایران زمین ', value: 'ZAMIN' },
        { name: ' پارسیان', value: 'BPARSI' },
        { name: ' پاسارگاد', value: 'BPASAR' },
        { name: 'پست بانک ', value: 'BPOST' },
        { name: ' توسعه صادرات  ایران', value: 'BEDIRA' },
        { name: ' تجارت ', value: 'BTEJAR' },
        { name: ' تجاری ایران و اروپا', value: 'EURO' },
        { name: 'تعاون اسلامی برای سرمایه‌گذاری', value: 'ESLA' },
        { name: ' توسعه تعاون', value: 'BCDEVE' },
        { name: ' خاورمیانه ', value: 'KHAVA' },
        { name: ' دی', value: 'BDAY' },
        { name: ' رفاه کارگران ', value: 'BREFAH' },
        { name: ' سامان ', value: 'BSAMAN' },
        { name: ' سرمایه ', value: 'BSARMA' },
        { name: ' سپه ', value: 'BSEPAH' },
        { name: ' سینا ', value: 'BSINA' },
        { name: ' شهر', value: 'BCITY' },
        { name: ' صنعت و معدن ', value: 'BINDMI' },
        { name: ' صادرات ', value: 'BSADER' },
        { name: 'فیوچر بانک (المستقبل)', value: 'FUTU' },
        { name: ' قرض الحسنه رسالت ', value: 'BRESALA' },
        { name: ' قرض الحسنه مهر ایران', value: 'BGHARZ' },
        { name: ' کارآفرین', value: 'BKARAF' },
        { name: ' کشاورزی', value: 'BKESHA' },
        { name: ' گردشگری ', value: 'BTOURI' },
        { name: ' مسکن', value: 'BMASKA' },
        { name: ' ملت', value: 'BMELLA' },
        { name: '  ملی ایران', value: 'BMELLI' },
        { name: ' مشترک ایران - ونزوئلا ', value: 'VENE' },
        { name: 'مؤسسه اعتباری غیربانکی کاسپین ', value: 'CASP' },
        { name: 'مؤسسه اعتباری غیربانکی  توسعه ', value: 'TOSE' },
        { name: 'مؤسسه اعتباری غیربانکی  ملل ', value: 'MELAL' },
        { name: 'مؤسسه اعتباری غیربانکی نور ', value: 'NOR' },
      ],
      GuaranteeTypes: [{
        id: 1,
        name: 'چک ضمانتی',
        codename: 'gc'
      },
      {
        id: 2,
        name: 'سفته',
        codename: 'pn'
      },
      {
        id: 3,
        name: 'ضمانت نامه بانکی',
        codename: 'bg'
      },
      ]
    }
  },
  methods: {
    getTypeName(codename) {
      if (this.chequeTypes.length) {
        let type = this.chequeTypes.find((o) => o.value == codename)
        if (type) {
          return type.text
        } else {
          console.error("Codename is incurrect:", codename, this.chequeTypes)
          return ''
        }
      } else {
        return ''
      }
    },
    getCheque(id) {
      this.getChequeMeta();
      return this.request({
        url: this.endpoint(`cheques/cheques/${id}`),
        method: 'get',
        success: data => {
          this.setItem(data);
        }
      })
    },
    getChequeMeta(reload) {
      this.fillStore({
        url: 'cheques/cheques/meta',
        storeKey: 'chequeMeta',
        reload: reload
      })
    },
  },
  computed: {
    ...mapState({
      chequeTypes: (state) => state.chequeMeta.types.map(o => { return { text: o[1], value: o[0] } }),
      chequeStatuses: (state) => state.chequeMeta.statuses.map(o => { return { text: o[1], value: o[0] } }),
      chequeOwnerTypes: (state) => state.chequeMeta.owner_types.map(o => { return { text: o[1], value: o[0] } }),
      chequeStatusTree: (state) => state.chequeMeta.tree,
    }),
    chequeGuaranteeTypes() {
      return this.chequeTypes.filter(o => this.$store.state.chequeMeta.guarantee_types.includes(o.value))
    }
  }
}